import { Outlet, useNavigate } from 'react-router-dom';
import { AppNavigation } from '../navigation/AppNavigation';
import { SIGN_IN_PATH } from '../../config/auth';
import { useAuth } from '../../providers/AuthProvider/AuthProvider';
import { AppDiv, MainContent } from './AppLayout.styled';

export function AppLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate(SIGN_IN_PATH, { replace: true });
  };

  return (
    <AppDiv>
      <AppNavigation
        onLogout={() => {
          void handleLogout();
        }}
      />
      <MainContent>
        <Outlet />
      </MainContent>
    </AppDiv>
  );
}
